<template>
  <v-container>
    <v-row>
      <v-col cols="7">
        <span class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{plural}}</h1>
          <v-btn fab x-small class="ml-2" color="success" @click="openCreateJobDialog()"><v-icon>mdi-plus</v-icon></v-btn>
        </span>
        <v-data-table
          :headers="headers"
          :items="allData"
          item-key="id"
          :options.sync="options"
          :server-items-length="pagination.dataCount"
          :loading="pagination.loading"
          :items-per-page="15"
          :footer-props="{
            itemsPerPageOptions: pagination.pageSizeOptions
          }"
          class="elevation-1"
          @click:row="rowClick"
        >
          <template v-slot:top>
            <v-text-field
              v-model="jobQuerySearch"
              label="Search..."
              class="mx-4"
              @input="searchJobs"
              clearable
            ></v-text-field>
          </template>
          <template v-slot:item.linkType="{ item }">
            <span>{{item.parentId?'🔗':''}}{{item.childJobs.length>0?'⭐':''}}</span>
          </template>
          <template v-slot:item.types="{ item }">
            <span>
              <span>[{{lookupLocationIcon(item.branchId)}}]</span>
              <span class="">{{item.type===0?'':(item.type===1?'👗':'💍')}}{{item.gender===0?'':(item.gender===1?'🤵':'👰')}}</span>
            </span>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="5" v-if="showSelected && selectedRow">
        <v-card outlined>
          <v-card-title class="d-flex flex-row">
            <span>
              <span v-if="selectedRow.childJobs&&selectedRow.childJobs.length>0">⭐</span>
              <span v-if="selectedRow.parentId">🔗</span>
              Job #{{selectedRow.id}} Details
            </span>
            <v-btn class="mx-2" @click="openPhotoDialog" color="success" x-small fab><v-icon>mdi-camera</v-icon></v-btn>
            <!-- <authorizer v-if="selectedRow.status>-1" v-bind:fabicon="'mdi-printer'" v-bind:color="'purple'" v-bind:dark="true" v-bind:authorization="this.authorizations.print" v-on:response="attemptPrint($event)"/> -->
            <v-btn :disabled="selectedRow.status<0" class="ml-2" fab x-small color="info" @click="printDirect({id:$route.query.selected})"><v-icon>mdi-printer</v-icon></v-btn>
            <v-btn :disabled="selectedRow.status<0||selectedRow.childJobs&&selectedRow.childJobs.length<1" class="ml-2" fab x-small color="purple" style="color:white" @click="printDirectBulk({id:$route.query.selected})"><v-icon>mdi-printer-settings</v-icon></v-btn>
            <v-btn class="mx-2" :disabled="isEditable || selectedRow.status===-1" @click="duplicateJob()" color="success" x-small fab><v-icon>mdi-content-copy</v-icon></v-btn>
            <v-btn class="mx-2" :disabled="isEditable || selectedRow.status===-1 || selectedRow.gender != 1" @click="openLinkJobDialog(selectedRow.id)" color="orange" style="color: white;" x-small fab><v-icon>mdi-link</v-icon></v-btn>
            <span v-if="!isEditable" class="d-flex flex-row">
              <v-btn v-if="selectedRow.Item.Customer.id" class="mx-1 mt-1" color="info" small @click="$router.push({path: `/customers`, query: {selected: selectedRow.Item.Customer.id}})">Customer <v-icon>mdi-arrow-right</v-icon></v-btn>
              <v-btn v-if="selectedRow.tailorId" class="mx-1 mt-1" color="info" small @click="$router.push({path: `/tailors`, query: {selected: selectedRow.tailorId}})">Tailor<v-icon>mdi-arrow-right</v-icon></v-btn>
              <v-btn v-if="selectedRow.customItem && selectedRow.customItem.id" class="mx-1 mt-1" color="info" small @click="$router.push({path: `/${selectedRow.customItem.type}s`, query: {selected: selectedRow.customItem.id}})">Item<v-icon>mdi-arrow-right</v-icon></v-btn>
              <v-btn v-if="selectedRow.eventId" class="mx-1 mt-1" color="info" small @click="$router.push({path: `/events`, query: {selected: selectedRow.eventId}})">Event<v-icon>mdi-arrow-right</v-icon></v-btn>
            </span>
          </v-card-title>
          <v-card-text class="d-flex flex-column">
            <span>
              <v-btn class="mx-2" :disabled="selectedRow.status<0 || selectedRow.status>2" small @click="toggleChanges">{{!isEditable?'Edit':'Cancel'}}</v-btn>
              <v-btn small @click="updateJob" color="success" v-if="isEditable" :disabled="!validUpdate" :loading="formLoader" class="mx-1">Save Changes</v-btn>
              <authorizer v-if="selectedRow.status===0" v-bind:disabled="!selectedRow.tailorId || isEditable || !selectedRow.dateOut" v-bind:fabicon="null" v-bind:buttontext="'Send Out'" v-bind:authorization="this.authorizations.sendOff" v-on:response="updateJobStatus('sendOff',$event)"/>
              <authorizer v-if="selectedRow.status===1" v-bind:disabled="isEditable || !selectedRow.dateIn" v-bind:fabicon="null" v-bind:buttontext="'Receive In'" v-bind:authorization="this.authorizations.receiveIn" v-on:response="updateJobStatus('receiveIn',$event)"/>
              <authorizer v-if="selectedRow.status===2" v-bind:disabled="isEditable || !selectedRow.dateToHand" v-bind:fabicon="null" v-bind:buttontext="'Cust. Collected'" v-bind:authorization="this.authorizations.handOff" v-on:response="updateJobStatus('handOff',$event)"/>
              <authorizer v-if="selectedRow.status===0 || selectedRow.status===2" v-bind:fabicon="null" v-bind:buttontext="'Void'" color="warning" v-bind:authorization="this.authorizations.void" v-on:response="updateJobStatus('void',$event)"/>
            </span>
            <span class="mt-2 d-flex flex-column">
              <span class="red--text" v-if="(selectedRow.status!==-1 && selectedRow.status!==3) && ((selectedRow.status>=0 && (!selectedRow.customItem || !selectedRow.Item.Customer.id || !selectedRow.tailorId || !selectedRow.dateOut)) || (selectedRow.status>=1 && !selectedRow.dateIn) || (selectedRow.status>=2 && !selectedRow.dateToHand))">
                To {{selectedRow.status===0?'Send Off':''}}{{selectedRow.status===1?'Receive In':''}}{{selectedRow.status===2?'Cust. Collected':''}}, please fill in the following fields.
                <span class="d-flex flex-column">
                  <span v-if="!selectedRow.Item.Customer.id">Customer</span>
                  <span v-if="!selectedRow.tailorId">Tailor</span>
                  <span v-if="!selectedRow.customItem">Item</span>
                  <span v-if="!selectedRow.dateOut">Date Out</span>
                  <span v-if="selectedRow.status===1 && !selectedRow.dateIn">Date In</span>
                  <span v-if="selectedRow.status===2 && !selectedRow.dateToHand">Due Date</span>
                </span>
              </span>
            </span>
            <span class="d-flex flex-row pt-3">
              <span class="d-flex flex-column pr-2">
                <span>Sent At: {{selectedRow.sentAt?momentDateFormat(selectedRow.sentAt, true):'-'}}</span>
                <span>Sent By: {{selectedRow.sentBy?this.lookupUsername(selectedRow.sentBy):'-'}}</span>
              </span>
              <span class="d-flex flex-column pr-2">
                <span>Rcvd At: {{selectedRow.receivedAt?momentDateFormat(selectedRow.receivedAt, true):'-'}}</span>
                <span>Rcvd By: {{selectedRow.receivedBy?this.lookupUsername(selectedRow.receivedBy):'-'}}</span>
              </span>
              <span class="d-flex flex-column pr-2">
                <span>Cust Cltd At: {{selectedRow.handedOffAt?momentDateFormat(selectedRow.handedOffAt, true):'-'}}</span>
                <span>Cust Cltd By: {{selectedRow.handedOffBy?this.lookupUsername(selectedRow.handedOffBy):'-'}}</span>
              </span>
              <span class="d-flex flex-column pr-2">
                <span>Void At: {{selectedRow.voidAt?momentDateFormat(selectedRow.voidAt, true):'-'}}</span>
                <span>Void By: {{selectedRow.voidBy?this.lookupUsername(selectedRow.voidBy):'-'}}</span>
              </span>
            </span>
            <v-form class="mt-5" :disabled="!isEditable || selectedRow.status===-1 || selectedRow.status===3" v-model="validUpdate">
<!--              <v-checkbox class="align-baseline mt-0 mb-0" v-model="selectedRow.metadata.isMaska" label="Maska" />-->
              <v-radio-group v-model="selectedRow.branchId" row>
                <v-radio v-for="(loc, i) in getLocations" :key="i" :label="loc.name" :value="loc.id"/>
              </v-radio-group>
              <span class="d-flex flex-row">
                <v-autocomplete
                  :items="customers"
                  :item-text="x => x.fullName + (x.phone?' | '+x.phone:'')"
                  item-value="id"
                  label="Customer"
                  :disabled="!isEditable || selectedRow.status!==0"
                  dense
                  outlined
                  @change="selectedCustomerChanged"
                  :rules="rules.required"
                  v-model="selectedRow.Item.Customer.id"
                />
                <v-btn class="ml-1" :disabled="!isEditable || selectedRow.status===-1 || selectedRow.status===3" @click="showCreateCustomerDialog('update')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-autocomplete
                    class="ml-2"
                    :items="tailors"
                    item-text="name"
                    item-value="id"
                    label="Tailor"
                    :disabled="!isEditable || selectedRow.status!==0"
                    outlined
                    dense
                    clearable
                    v-model="selectedRow.tailorId"
                />
                <!--<v-btn class="ml-1" :disabled="!isEditable || selectedRow.status===-1 || selectedRow.status===3" @click="showCreateTailorDialog" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>-->
              </span>
              <span class="d-flex flex-row">
                <v-select
                    class=""
                    :items="jobTypes"
                    item-text="name"
                    item-value="id"
                    label="Type"
                    :disabled="!isEditable || selectedRow.status!==0||(selectedRow.parentId!==null||selectedRow.childJobs.length>0)"
                    outlined
                    dense
                    v-model="selectedRow.type"
                />
                <v-select
                    class="ml-2"
                    :items="genders"
                    item-text="name"
                    item-value="id"
                    label="Gender"
                    :disabled="!isEditable || selectedRow.status!==0||(selectedRow.parentId!==null||selectedRow.childJobs.length>0)"
                    outlined
                    dense
                    v-model="selectedRow.gender"
                />
              </span>
              <span class="d-flex flex-row">
                <v-btn x-small class="mr-2" fab color="info" v-if="(isAllowed('job', 'viewRevenue'))&&this.selectedRow.status!==-1&&!isEditable" @click="showEditTailorCostPostComplete"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-text-field v-if="isAllowed('job', 'viewRevenue')" class="mr-2" outlined dense label="Tailor Cost" v-model="selectedRow.tailorCost"/>
                <v-btn x-small class="mr-2" fab color="info" v-if="this.selectedRow.status!==-1&&!isEditable" @click="showEditCustomerCostPostComplete"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-text-field class="mr-2" outlined dense label="Customer Price" v-model="selectedRow.totalCost"/>
                <span v-if="isAllowed('job', 'viewRevenue')" style="width: 200px;">Revenue: {{selectedRow.totalCost-selectedRow.tailorCost||0}}</span>
              </span>
              <span class="d-flex flex-column ">
                <span class="d-flex flex-row">
                  <v-autocomplete
                    :items="selectedItems"
                    item-text="name"
                    return-object
                    :label="selectedRow.Item.Customer.id?'Item':'Select a customer first...'"
                    outlined
                    dense
                    hint="Item"
                    @change="itemChanged"
                    :persistent-hint="selectedRow.Item.Customer.id==null"
                    :loading="loadingItems"
                    :disabled="!isEditable || !selectedRow.Item.Customer.id || selectedRow.status!==0||(selectedRow.parentId!==null||selectedRow.childJobs.length>0)"
                    :rules="rules.required"
                    v-model="selectedRow.customItem"
                  />
                  <v-btn class="ml-1 mr-2" :disabled="!selectedRow.Item.Customer.id || !isEditable || selectedRow.status!==0" @click="showCreateAssetDialog('update')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                  <v-text-field outlined dense v-if="selectedRow.customItem && selectedRow.customItem.type==='asset'" label="Colour" v-model="selectedRow.customItem.colour"/>
                </span>
              </span>
              <span class="d-flex flex-row">
                <v-menu
                    :close-on-content-click="false"
                    :nudge-right="0"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="momentDateFormat(selectedRow.dateOut)"
                        label="Date Out"
                        readonly
                        dense
                        outlined
                        clearable
                        :disabled="!isEditable || selectedRow.status>0"
                        v-bind="attrs"
                        v-on="on"
                        class="mr-2"
                    />
                  </template>
                  <v-date-picker
                      :disabled="!isEditable || selectedRow.status>0"
                      v-model="selectedRow.dateOut"
                  />
                </v-menu>
                <v-menu
                    :close-on-content-click="false"
                    :nudge-right="0"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="momentDateFormat(selectedRow.dateIn)"
                        label="Date In"
                        readonly
                        dense
                        outlined
                        clearable
                        :disabled="!isEditable || selectedRow.status>1"
                        v-bind="attrs"
                        v-on="on"
                        class="mr-2"
                    />
                  </template>
                  <v-date-picker
                      :disabled="!isEditable || selectedRow.status>1"
                      v-model="selectedRow.dateIn"
                  />
                </v-menu>
                <v-menu
                    :close-on-content-click="false"
                    :nudge-left="80"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="momentDateFormat(selectedRow.dateToHand)"
                        label="Date Due"
                        readonly
                        dense
                        outlined
                        clearable
                        v-bind="attrs"
                        v-on="on"
                        class="mr-2"
                    />
                  </template>
                  <v-date-picker
                      v-model="selectedRow.dateToHand"
                  />
                </v-menu>
              </span>
              <span class="d-flex flex-row ">
                <v-autocomplete
                  :items="events"
                  :item-text="x => x.name + ` (ID: ${x.id}, Customer: ${x.Customer?x.Customer.fullName:'ERROR'})`"
                  item-value="id"
                  label="Event (Optional)"
                  dense
                  clearable
                  outlined
                  v-model="selectedRow.eventId"
                />
                <v-btn class="ml-1 mr-2" :disabled="!isEditable || selectedRow.status===-1 || selectedRow.status===3" @click="showCreateEventDialog('update')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-text-field class="" dense outlined label="Transaction ID" v-model="selectedRow.transactionId"/>
              </span>
              <span>
                <v-autocomplete
                    :items="pinners"
                    :item-text="x => lookupUsername(x.id)"
                    item-value="id"
                    label="Pinned By"
                    dense
                    :disabled="!isEditable || selectedRow.status!==0||(selectedRow.parentId!==null||selectedRow.childJobs.length>0)"
                    clearable
                    outlined
                    v-model="selectedRow.pinnedBy"
                />
              </span>
              <span v-if="selectedRow.gender===1">
                <v-autocomplete
                    :items="alterationTypes"
                    :loading="alterationsLoading"
                    outlined
                    deletable-chips
                    :disabled="selectedRow.status!==0"
                    dense
                    label="Alteration Type"
                    item-text="name"
                    item-value="id"
                    v-model="selectedRow.alterationType"
                    @change="loadAlterations(false)"
                />
              </span>
              <span v-if="selectedRow.gender===1">
                <v-autocomplete
                    :items="alterations"
                    :loading="alterationsLoading"
                    :disabled="selectedRow.alterationType===null || selectedRow.status!==0"
                    multiple
                    chips
                    dense
                    label="Current Alterations"
                    outlined
                    deletable-chips
                    return-object
                    :item-text="(x => {return `${x.name} ($${x.price})`})"
                    v-model="selectedRow.itemAlterations"
                    @change="calculateCustomerCost"
                />
              </span>
              <span>
                <h4>Related Jobs</h4>
                <v-data-table
                    :headers="relatedJobsHeaders"
                    :items="selectedRow.relatedJobs"
                    item-key="id"
                    :items-per-page="-1"
                    class="elevation-1 mb-2"
                    @click:row="rowClick"
                >
                  <template v-slot:item.parsedStatus="{ item }">
                    {{utils.parseJobStatus(item.status)}}
                  </template>
                  <template v-slot:item.id="{ item }">
                    <span v-if="item.parentId==null">⭐</span><span v-else>🔗</span>{{item.id}}
                  </template>
                  <template v-slot:item.tailor="{ item }">
                    <span>{{lookupTailorName(item.tailorId).name}}</span>
                  </template>
                  <template v-slot:item.itemAlterations="{ item }">
                    <span v-for="alt in item.itemAlterations" :key="alt.id">
                      <v-chip class="mr-1" x-small><b>{{(alterationTypes.find(x => x.id===item.alterationType)?alterationTypes.find(x => x.id===item.alterationType).name:'')}} - {{alt.name}}</b></v-chip>
                    </span>
                    <!-- {{item.itemAlterations}} -->
                  </template>
                </v-data-table>
              </span>
              <span>
                <h4>Appointment</h4>
                <v-card class="mb-2" v-if="selectedRow.Appointment" @click="$router.push(`/appointments/view/${selectedRow.Appointment.id}`)" outlined elevation="0">
                  <v-card-text class="d-flex flex-row justify-space-around">
                    <span class="d-flex flex-column">
                      <h3>Appointment #{{selectedRow.Appointment.id}}</h3>
                    </span>
                    <span class="d-flex flex-column">
                      <span>Scheduled For: {{utils.customFormatDate(selectedRow.Appointment.scheduledFor)}}</span>
                      <span>Wedding Date: {{utils.customFormatDate(selectedRow.Appointment.weddingDate, "notime")}}</span>
                    </span>
                    <span class="d-flex flex-column">
                      <span v-if="appointmentTypes.length>0 && selectedRow.Appointment.appointmentType">Appointment Type: {{appointmentTypes.find(x => x.id===(selectedRow.Appointment.appointmentType)).name}}</span>
                      <span>Status: {{utils.parseAppointmentStatus(selectedRow.Appointment.status)}}</span>
                    </span>
                  </v-card-text>
                </v-card>
                <span v-else>No Appointment Associated.</span>
              </span>
              <span>
                <v-textarea label="Notes" v-model="selectedRow.alterations" dense outlined/>
              </span>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="createJobDialog" max-width="800">
      <v-card>
        <v-card-title>Create New Job {{appointmentData.id?`for Appointment #${appointmentData.id}`:''}}</v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreate" class="d-flex flex-column justify-start">
<!--            <v-checkbox class="align-baseline mt-0 mb-0" v-model="formData.metadata.isMaska" label="Maska" />-->
            <span>
              <v-radio-group v-model="formData.branchId" row>
                <v-radio v-for="(loc, i) in getLocations" :key="i" :label="loc.name" :value="loc.id"/>
              </v-radio-group>
            </span>
            <span class="d-flex flex-row">
              <v-autocomplete
                  :items="customers"
                  :item-text="x => x.fullName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
                  item-value="id"
                  label="Customer"
                  dense
                  outlined
                  clearable
                  :disabled="formData.appointmentId!=null"
                  @change="createdCustomerChanged"
                  :rules="rules.required"
                  v-model="formData.Item.customerId"
              />
              <v-btn class="ml-1 mr-2" @click="showCreateCustomerDialog('create')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              <v-autocomplete
                  :items="tailors"
                  item-text="name"
                  item-value="id"
                  label="Tailor"
                  outlined
                  dense
                  clearable
                  v-model="formData.tailorId"
                  class="mr-2"
              />
            </span>
            <span class="d-flex flex-row">
              <v-select
                  class=""
                  :items="jobTypes"
                  item-text="name"
                  item-value="id"
                  label="Type"
                  outlined
                  dense
                  v-model="formData.type"
              />
              <v-select
                  class="ml-2"
                  :items="genders"
                  item-text="name"
                  item-value="id"
                  label="Gender"
                  outlined
                  dense
                  v-model="formData.gender"
              />
            </span>
            <span class="d-flex flex-row">
              <v-text-field v-if="isAllowed('job', 'viewRevenue')" class="mr-2" outlined dense label="Tailor Cost" v-model="formData.tailorCost"/>
              <v-text-field class="mr-2" outlined dense label="Customer Price" v-model="formData.totalCost"/>
              <span v-if="isAllowed('job', 'viewRevenue')" style="width: 200px;">Revenue: {{formData.totalCost-formData.tailorCost||0}}</span>
            </span>
            <span class="d-flex flex-column">
              <span class="d-flex flex-row">
                <v-autocomplete
                    :items="items"
                    item-text="name"
                    return-object
                    :label="formData.Item.customerId?'Item':'Select a customer first...'"
                    outlined
                    dense
                    clearable
                    hint="Item"
                    :persistent-hint="formData.Item.customerId==null"
                    :loading="loadingItems"
                    :disabled="!formData.Item.customerId"
                    :rules="rules.required"
                    v-model="formData.Item.item"
                />
                <v-btn class="ml-1" @click="showCreateAssetDialog('create')" :disabled="!formData.Item.customerId" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-text-field class="ml-2" outlined dense v-if="formData.Item && formData.Item.item && formData.Item.item.type==='asset'" label="Colour" v-model="formData.Item.item.colour"/>
              </span>
            </span>
            <span class="d-flex flex-row">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="0"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(formData.dateOut)"
                      label="Date Out"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="formData.dateOut"
                />
              </v-menu>
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="0"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(formData.dateIn)"
                      label="Date In"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="formData.dateIn"
                />
              </v-menu>
              <v-menu
                  :close-on-content-click="false"
                  :nudge-left="50"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(formData.dateToHand)"
                      label="Date Due"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="formData.dateToHand"
                />
              </v-menu>
            </span>
            <span class="d-flex flex-row ">
                <v-autocomplete
                    :items="events"
                    :item-text="x => x.name + ` (ID: ${x.id}, Customer: ${x.Customer?x.Customer.fullName:'ERROR'})`"
                    item-value="id"
                    label="Event (Optional)"
                    dense
                    clearable
                    outlined
                    v-model="formData.eventId"
                />
                <v-btn class="ml-1 mr-2" @click="showCreateEventDialog('create')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-text-field class="" dense outlined label="Transaction ID" v-model="formData.transactionId"/>
              </span>
            <span>
                <v-autocomplete
                    :items="pinners"
                    :item-text="x => lookupUsername(x.id)"
                    item-value="id"
                    label="Pinned By"
                    dense
                    clearable
                    outlined
                    v-model="formData.pinnedBy"
                />
            </span>
            <span v-if="formData.gender===1">
              <span class="d-flex flex-row align-center">
                <h4>Alteration Type</h4>
              </span>
              <v-autocomplete
                  :items="alterationTypes"
                  :loading="alterationsLoading"
                  outlined
                  deletable-chips
                  dense
                  item-text="name"
                  item-value="id"
                  v-model="formData.alterationType"
                  @change="loadAlterations(true)"
              />
            </span>
            <span v-if="formData.gender===1">
              <span class="d-flex flex-row align-center">
                <h4>Current Alterations</h4>
              </span>
              <v-autocomplete
                  :items="formDataAlterations"
                  :loading="alterationsLoading"
                  :disabled="formData.alterationType===null"
                  multiple
                  chips
                  dense
                  outlined
                  deletable-chips
                  return-object
                  :item-text="(x => {return `${x.name} ($${x.price})`})"
                  v-model="formData.itemAlterations"
                  @change="calculateCustomerCostForNewUnlinkedJob"
              />
            </span>
            <span>
                <v-textarea label="Notes" v-model="formData.alterations" dense outlined/>
            </span>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateJobDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreate" @click="saveJob" :loading="createJobLoading">Create</v-btn>
<!--          <v-btn color="info" @click="resetCreateJobDialog">Reset</v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="linkJobDialog.isOpen" max-width="800">
      <v-card>
        <v-card-title>
          🔗 Link New Job to #{{linkJobDialog.jobData.parentId}}
        </v-card-title>
        <v-card-text v-if="linkJobDialog.jobData && linkJobDialog.jobData.Item" class="pa-5">
          <v-form v-model="validCreateLink" ref="createLinkJobForm" class="d-flex flex-column justify-start">
            <span class="d-flex flex-row">
              <v-autocomplete
                  :items="customers"
                  :item-text="x => x.fullName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
                  item-value="id"
                  label="Customer"
                  dense
                  outlined
                  disabled
                  v-model="linkJobDialog.jobData.Item.customerId"
              />
              <v-autocomplete
                  :items="tailors"
                  item-text="name"
                  item-value="id"
                  label="Tailor"
                  outlined
                  dense
                  :rules="rules.required"
                  v-model="linkJobDialog.jobData.tailorId"
                  class="mr-2"
              />
            </span>
            <span class="d-flex flex-row">
              <v-select
                  class=""
                  :items="jobTypes"
                  item-text="name"
                  item-value="id"
                  label="Type"
                  outlined
                  dense
                  disabled
                  v-model="linkJobDialog.jobData.type"
              />
              <v-select
                  class="ml-2"
                  :items="genders"
                  item-text="name"
                  item-value="id"
                  label="Gender"
                  outlined
                  dense
                  disabled
                  v-model="linkJobDialog.jobData.gender"
              />
            </span>
            <span class="d-flex flex-row">
              <v-text-field v-if="isAllowed('job', 'viewRevenue')" class="mr-2" outlined dense label="Tailor Cost" v-model="linkJobDialog.jobData.tailorCost"/>
              <v-text-field class="mr-2" outlined dense label="Customer Price" v-model="linkJobDialog.jobData.totalCost"/>
              <span v-if="isAllowed('job', 'viewRevenue')" style="width: 200px;">Revenue: {{linkJobDialog.jobData.totalCost-linkJobDialog.jobData.tailorCost||0}}</span>
            </span>
            <span class="d-flex flex-column">
              <span class="d-flex flex-row">
                <v-text-field class="ml-2" outlined dense v-if="linkJobDialog.jobData.Item" label="Item" disabled v-model="linkJobDialog.jobData.item"/>
              </span>
            </span>
            <span class="d-flex flex-row">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="0"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(linkJobDialog.jobData.dateOut)"
                      label="Date Out"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="linkJobDialog.jobData.dateOut"
                />
              </v-menu>
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="0"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(linkJobDialog.jobData.dateIn)"
                      label="Date In"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="linkJobDialog.jobData.dateIn"
                />
              </v-menu>
              <v-menu
                  :close-on-content-click="false"
                  :nudge-left="50"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="momentDateFormat(linkJobDialog.jobData.dateToHand)"
                      label="Date Due"
                      readonly
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                  />
                </template>
                <v-date-picker
                    v-model="linkJobDialog.jobData.dateToHand"
                />
              </v-menu>
            </span>
            <span class="d-flex flex-row ">
                <v-autocomplete
                    :items="events"
                    :item-text="x => x.name + ` (ID: ${x.id}, Customer: ${x.Customer?x.Customer.fullName:'ERROR'})`"
                    item-value="id"
                    label="Event (Optional)"
                    dense
                    clearable
                    outlined
                    disabled
                    v-model="linkJobDialog.jobData.eventId"
                />
                <v-btn class="ml-1 mr-2" disabled @click="showCreateEventDialog('create')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                <v-text-field class="" disabled dense outlined label="Transaction ID" v-model="linkJobDialog.jobData.transactionId"/>
              </span>
            <span>
                <v-autocomplete
                    :items="users"
                    :item-text="x => this.lookupUsername(x.id)"
                    item-value="id"
                    label="Pinned By"
                    dense
                    clearable
                    outlined
                    disabled
                    v-model="linkJobDialog.jobData.pinnedBy"
                />
            </span>
            <span v-if="linkJobDialog.jobData.gender===1">
              <span class="d-flex flex-row align-center">
                <h4>Alteration Type</h4>
              </span>
              <v-autocomplete
                  :items="alterationTypes"
                  :loading="alterationsLoading"
                  outlined
                  deletable-chips
                  dense
                  item-text="name"
                  item-value="id"
                  @change="loadAlterations(false, true)"
                  v-model="linkJobDialog.jobData.alterationType"
              />
            </span>
            <span v-if="linkJobDialog.jobData.gender===1">
              <span class="d-flex flex-row align-center">
                <h4>Current Alterations</h4>
              </span>
              <v-autocomplete
                  :items="linkJobDialog.jobDataAlterations"
                  :loading="alterationsLoading"
                  :disabled="linkJobDialog.jobData.alterationType===null"
                  multiple
                  chips
                  dense
                  outlined
                  deletable-chips
                  return-object
                  :item-text="(x => {return `${x.name} ($${x.price})`})"
                  v-model="linkJobDialog.jobData.itemAlterations"
                  @change="calculateCustomerCostForNewLinkJob"
              />
            </span>
            <span>
                <v-textarea label="Notes" v-model="linkJobDialog.jobData.alterations" dense outlined/>
            </span>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeLinkJobDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateLink||linkJobDialog.jobData.gender!=1||linkJobDialog.jobData.itemAlterations.length<1" @click="createLinkedJob" :loading="linkJobDialog.loading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createEventDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create New Event
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateEvent">
            <span class="d-flex flex-row">
                <v-autocomplete
                    :items="customers"
                    :item-text="x => x.fullName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
                    item-value="id"
                    label="Primary Customer"
                    dense
                    outlined
                    :rules="rules.required"
                    v-model="newEvent.customerId"
                />
                <v-btn class="ml-1" @click="showCreateCustomerDialog('event')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              </span>
            <v-text-field
                label="Name"
                outlined
                :rules="rules.required"
                v-model="newEvent.name"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateEvent">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateEvent" @click="createEvent(eventUsage)" :loading="eventLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createAssetDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create New Asset (Default Item)
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateAsset">
            <v-text-field
                label="Style No."
                outlined
                :rules="rules.required"
                v-model="newAsset.styleNo"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateAsset">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateAsset" @click="createAsset(assetUsage)" :loading="assetLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog fullscreen persistent v-model="photoDialog.isOpen">
      <v-card>
        <v-card-title class="d-flex flex-row align-space-between">
          <span>Photos for Job # {{selectedRow?selectedRow.id:''}}</span>
          <v-btn fab color="error" x-small @click="closePhotoDialog()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-5 d-flex flex-row">
            <v-card width='740px' outlined>
              <v-card-title>Add Photo</v-card-title>
              <v-card-text>
                  <span v-if="photoDialog.flash" style="width: 10px; height: 10px; border-radius: 10px; background-color: red;"></span>
                  <video v-show="!photoDialog.isPhotoTaken" autoplay="true" ref="camera" style="width: 700px; height: 525px;" id="videoElement"></video>
                  <canvas v-show="photoDialog.isPhotoTaken" id="photoTaken" ref="canvas" width="700px" height="525px"></canvas>
              </v-card-text>
              <v-card-actions>
                <v-btn :disabled="photoDialog.isPhotoTaken" color="info" @click="takePhoto()">Take Photo</v-btn>
                <v-btn :disabled="photoDialog.isPhotoTaken" color="success" :loading="photoDialog.snapAndSaveLoader" @click="snapAndSave()">Snap and Save</v-btn>
                <v-btn :disabled="!photoDialog.isPhotoTaken" color="warning" @click="retryPhoto()">Retry</v-btn>
                <v-btn :disabled="!photoDialog.isPhotoTaken" color="success" :loading="photoDialog.addPhotoLoader" @click="addPhotoToJob()">Add Photo to Job</v-btn>
              </v-card-actions>
            </v-card>
            <v-card outlined>
              <v-img :src="photoDialog.photoToDisplay" width="800px"/>
              <v-card-text>
                <span v-if="this.photosOnSelectedJob">
                  <span class="d-flex flex-row flex-wrap-nowrap" style="width: 800px; overflow-x:scroll;">
                    <span style="background-color: rgba(0,0,0,0.25); padding: 5px; border-radius: 5px;" class="d-flex flex-column mr-2" v-for="(img, index) in selectedRow.metadata.media" :key="index">
                      <img @click="setPhotoToDisplay(img.url)" :src="img.url"  :alt="img.url" width="140px">
                      <span class=" mt-2 mb-4 d-flex flex-row justify-center">
                        <v-btn class="mr-2" @click="deletePhoto(img.url)" x-small color="error">Delete</v-btn>
                        <a style="text-decoration: none;" :href="img.url" target="__blank">
                          <v-btn icon x-small color="info"><v-icon>mdi-open-in-new</v-icon></v-btn>
                        </a>
                      </span>
                    </span>
                  </span>
                </span>
              </v-card-text>
            </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="editTailorCostPostComplete.isOpen" max-width="600">
      <v-card>
        <v-card-title>
          Edit Tailor Cost
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="editTailorCostPostComplete.isValid">
            <v-text-field
                autofocus
                label="Tailor Cost"
                outlined
                :rules="rules.required"
                v-model="editTailorCostPostComplete.value"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeEditTailorCostPostComplete">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!editTailorCostPostComplete.isValid" @click="editTailorCost()" :loading="editTailorCostPostComplete.loading">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="editCustomerCostPostComplete.isOpen" max-width="600">
      <v-card>
        <v-card-title>
          Edit Customer Cost
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="editCustomerCostPostComplete.isValid">
            <v-text-field
                autofocus
                label="New Customer Cost"
                outlined
                :rules="rules.required"
                v-model="editCustomerCostPostComplete.value"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeEditCustomerCostPostComplete">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!editCustomerCostPostComplete.isValid" @click="editCustomerCost()" :loading="editCustomerCostPostComplete.loading">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createTailorDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create Tailor
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateTailor">
            <v-text-field
                label="Name"
                outlined
                :rules="rules.required"
                v-model="newTailor.name"
            />
            <v-text-field
                label="Phone"
                outlined
                v-model="newTailor.phone"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateTailor">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateTailor" @click="createTailor" :loading="tailorLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createCustomerDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create Customer
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateCustomer">
            <v-text-field
                label="First Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.firstName"
                @input="existingData=null"
            />
            <v-text-field
                label="Last Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.lastName"
                @input="existingData=null"
            />
            <v-text-field
                label="Phone"
                outlined
                v-model="newCustomer.phone"
                @input="existingData=null"
            />
            <v-text-field
                label="Email"
                outlined
                v-model="newCustomer.email"
                @input="existingData=null"
            />
            <span>
              <h3>Address</h3>
              <v-text-field
                  label="Address Line 1"
                  outlined
                  v-model="newCustomer.address.line1"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Address Line 2"
                  outlined
                  v-model="newCustomer.address.line2"
                  @input="existingData=null"
              />
              <v-text-field
                  label="City"
                  outlined
                  v-model="newCustomer.address.city"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Notes"
                  outlined
                  v-model="newCustomer.notes"
                  @input="existingData=null"
              />
            </span>
          </v-form>
          <div v-if="existingData">
            <p class="red--text">A Customer with this phone number already exists. Are you sure you want to create another?</p>
            <h3>Or choose the existing Customer</h3>
            <v-btn color="info" @click="existingCustomerSelected">{{existingData.firstName}} {{existingData.lastName}}</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateCustomer">
            Cancel
          </v-btn>
          <v-btn color="success" v-if="!existingData" :disabled="!validCreateCustomer" @click="createCustomer(customerUsage)" :loading="customerLoading">Create</v-btn>
          <v-btn v-else color="success" :disabled="!validCreateCustomer" @click="confirmCreateCustomer(customerUsage)" :loading="customerLoading">Create New</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="confirmDeleteDialog" max-width="400">
      <v-card class="align-center">
        <v-card-title>
          Void {{singular}}
        </v-card-title>
        <v-card-text class="pa-5 text-center">
          <span>Are you sure you want to void this {{singularLower}}?</span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="closeDeleteDialog">
            Cancel
          </v-btn>
          <v-btn color="warning" @click="voidJob" :loading="deleteLoading">Void</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import axios from 'axios';
import moment from "moment";
import {mapGetters, mapMutations} from "vuex";
import utils from "../../plugins/helpers";
import authorizer from "../../components/authorizer.vue"
import _ from 'lodash';
export default {
  components: {
    authorizer
  },
  data () {
    return {
      utils: utils,

      isEditable: false,
      snackObj: {
        color: '',
        text: ''
      },

      manualRoute: false,

      jobQuerySearch: '',

      prevRow: [],

      rules: {
        required: [v => !!v || 'This field is required.'],
      },
      validCreate: false,
      validCreateLink: false,
      validUpdate: false,
      validCreateCustomer: false,
      validCreateAsset: false,
      validCreateTailor: false,
      validCreateEvent: false,
      createJobDialog: false,
      headers: [
        { text: 'Link', align: 'start', sortable: false, value: 'linkType' },
        { text: 'Types', align: 'start', sortable: false, value: 'types' },
        { text: 'ID', align: 'start', sortable: true, value: 'id' },
        { text: 'Customer', sortable: false, value: 'customer' },
        { text: 'Item', sortable: false, value: 'item' },
        { text: 'Date Out', sortable: true, value: 'out' },
        { text: 'Date In', sortable: true, value: 'in' },
        { text: 'Date Due', sortable: true, value: 'hand' },
        { text: 'Tailor', sortable: false, value: 'tailor' },
        { text: 'Status', sortable: true, value: 'parsedStatus' }
      ],
      relatedJobsHeaders: [
        { text: 'ID', align: 'start', sortable: true, value: 'id' },
        { text: 'Status', value: 'parsedStatus' },
        { text: 'Tailor', sortable: true, value: 'tailor' },
        { text: 'Alterations', sortable: true, value: 'itemAlterations' },
      ],
      allData: [],
      formData: {Item: {item: null}, gender: 0, type: 0, metadata: {}},

      alterationsHeader: [
        { text: 'Name', align: 'start', sortable: true, value: 'name' },
        { text: 'Price', sortable: true, value: 'price' },
      ],

      jobTypes: [
        {name: "None",id: 0},
        {name: "Formal 👗",id: 1},
        {name: "Bridal 💍",id: 2}
      ],
      genders: [
        {name: "None",id: 0},
        {name: "Male 🤵",id: 1},
        {name: "Female 👰",id: 2}
      ],

      formLoader: false,
      deleteLoading: false,
      confirmDeleteDialog: false,

      selectedRow: null,
      selectedItems: [],
      showSelected: false,

      assets: [],
      createAssetDialog: false,
      newAsset: {},
      assetLoading: false,
      assetUsage: "create",

      editTailorCostPostComplete: {
        isOpen: false,
        value: 0,
        loading: false,
        isValid: false,
      },


      editCustomerCostPostComplete: {
        isOpen: false,
        value: 0,
        loading: false,
        isValid: false,
      },

      tailors: [],
      createTailorDialog: false,
      newTailor: {},
      tailorLoading: false,

      events: [],
      createEventDialog: false,
      newEvent: {},
      eventLoading: false,
      eventUsage: "create",

      customers: [],
      createCustomerDialog: false,
      newCustomer: {address: {}},
      customerLoading: false,
      customerUsage: "create",

      existingData: null,

      items: [],
      loadingItems: false,

      alterationTypes: [],
      alterations: [],
      formDataAlterations: [],

      alterationsLoading: false,

      users: [],
      pinners: [],
      appointmentTypes: [],

      pluralLower: "jobs",
      plural: "Jobs",
      singularLower: "job",
      singular: "Job",
      createJobLoading: false,
      authorizations: {
        print: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'printJobTicket', key:'printJobTicket'},
        sendOff: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatus', key:'sendOff'},
        receiveIn: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatus', key:'receiveIn'},
        handOff: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatus', key:'handOff'},
        void: {type: 'scanAuthorize', authorized: false, authorizerId: '', resource: 'job', requiredPerm: 'modifyJobStatus', key:'void'},
      },
      photoDialog: {
        isOpen: false,
        isPhotoTaken: false,
        flash: false,
        addPhotoLoader: false,
        snapAndSaveLoader: false,
        photoToDisplay: '',
      },
      linkJobDialog: {
        isOpen: false,
        loading: false,
        jobData: {}
      },

      appointmentData: {
        id: null
      },

      pagination: {
        loading: false,
        dataCount: 0,
        pageSizeOptions: [5, 10, 15, 30, -1]
      },
      options: {
        search: "",
        sortBy: ['id'],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 15
      },
      updatingRoute: false,
      init: false,
    }
  },
  async created(){
    try{
      this.init = true;
      //used for pagination
      let oldQuery = this.getURLQuery();
      this.options.page = oldQuery.page || 1;
      this.options.itemsPerPage = oldQuery.limit || 15
      this.options.sortBy = [oldQuery.sort || "createdAt"]
      this.options.sortDesc = [oldQuery.order || false]
      this.options.search = oldQuery.search || ""
      this.jobQuerySearch = this.options.search;
      //used for pagination end
    }
    catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    }
  },
  async mounted(){
    try {
      let res;
      res = await axios.get(`${this.getEndpoint}/api/customers`)
      if(res.data.error) throw res.data.error;
      this.customers = res.data.data;

      res = await axios.get(`${this.getEndpoint}/api/users`)
      if(res.data.error) throw res.data.error;
      this.users = res.data;

      this.pinners = this.users.filter(x => {
        return x.UserType?.name==="Pinner" // the lack of a ? caused a bug on 13/04/23. Further investigation needed
      });

      res = await axios.get(`${this.getEndpoint}/api/assets`)
      if(res.data.error) throw res.data.error;
      this.assets = res.data.data;

      res = await axios.get(`${this.getEndpoint}/api/alterationTypes`)
      if(res.data.error) throw res.data.error;
      this.alterationTypes = res.data.data;

      res = await axios.get(`${this.getEndpoint}/api/events/lite`)
      if(res.data.error) throw res.data.error;
      this.events = res.data.data;

      res = await axios.get(`${this.getEndpoint}/api/tailors/excludeHidden`)
      if(res.data.error) throw res.data.error;
      this.tailors = res.data.data;

      res = await axios.get(`${this.getEndpoint}/api/appointmentTypes`)
      if(res.data.error) throw res.data.error
      this.appointmentTypes = res.data.data

      if(this.$route.query.createFromAppointment){
        let appointmentValues = JSON.parse(this.$route.query.createFromAppointment);
        await this.openCreateJobDialog(appointmentValues);
      }

      this.init = true;

      this.pagination.pageSizeOptions = this.getGlobalValue("paginationPageLimitsGeneral")?.split(",").map(x => parseInt(x)) || this.pagination.pageSizeOptions;
      this.init = false;
    } catch (error) {
      console.error(error);
      this.snack(error.msg || error, "error");
    }
  },
  watch: {
    options: {
      async handler () {
        await this.getAllData();
      },
      deep: true,
    },
    $route: {
      handler: async function (current) {
        //used for pagination
        if (this.updatingRoute || this.manualRoute) return;
        let oldQuery = this.getURLQuery(current.query);
        this.options.page = oldQuery.page || 1;
        this.options.itemsPerPage = oldQuery.limit || 15
        this.options.sortBy = [oldQuery.sort || "createdAt"]
        this.options.sortDesc = [oldQuery.order || false]
        this.options.search = oldQuery.search || ""
        //used for pagination end include full watcher
        await this.changeSelectedRow();
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['getEndpoint', 'lookupUsername', "isAllowed", "getGlobalValue", "getLocations", 'lookupLocation', 'lookupLocationIcon']),
    photosOnSelectedJob(){
      return this.selectedRow?.metadata?.media?.length>0
    }
  },
  methods: {
    ...mapMutations([
      'lockGlobalQueryBc',
      'unlockGlobalQueryBc',
      'openSIDAuthorizer',
      'closeSIDAuthorizer',
    ]),
    // async searchJobs(){
    //   this.options.search = this.jobQuerySearch;
    //   console.log("wow")
    //   await _.debounce(function(){
    //     console.log("meow")
    //     this.options.search = this.jobQuerySearch;
    //   }, 100)
    // },
    searchJobs: _.debounce(function(){
      this.options.search = this.jobQuerySearch;
      if(!this.options.search) this.options.search = "" //added in so when clearable is clicked, the table resets properly
      this.getAllData()
    }, 700),
    getURLQuery(custom=null){
      let oldQuery = custom? {...custom}: {...this.$route.query};
      if(oldQuery.limit) oldQuery.limit = parseInt(oldQuery.limit);
      if(oldQuery.page) oldQuery.page = parseInt(oldQuery.page);
      if(oldQuery.order) oldQuery.order = oldQuery.order==='true';
      if(oldQuery.selected) oldQuery.selected = parseInt(oldQuery.selected);
      return oldQuery;
    },
    duplicateJob(){
      this.createJobDialog = true
      this.formData = {...this.selectedRow}
      this.formData.tailorCost = 0
      this.formData.dateOut = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.items = this.selectedItems
      this.loadAlterations(true)
    },
    calculateCustomerCost(){
      this.selectedRow.totalCost = this.selectedRow.itemAlterations.reduce((acc,x)=>acc+parseFloat(x.price),0)
    },
    calculateCustomerCostForNewUnlinkedJob(){
      this.formData.totalCost = this.formData.itemAlterations.reduce((acc,x)=>acc+parseFloat(x.price),0)
    },
    calculateCustomerCostForNewLinkJob(){
      this.linkJobDialog.jobData.totalCost = this.linkJobDialog.jobData.itemAlterations.reduce((acc,x)=>acc+parseFloat(x.price),0)
    },
    async printDirect(obj){
      try {
        let x = await axios.post(`${this.getEndpoint}/api/print/preview/invoice/${obj.id}`)
        if(x.data.error) throw x.data.error
        let printWindow = open("","Printing")
        printWindow.document.write(x.data.data.job.htmlToPrint)
        printWindow.setTimeout(()=>{
          printWindow.print()
          printWindow.document.write("")
        },500)
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error")
      }
    },
    async printDirectBulk(){
      try {
        console.log(this.selectedRow)
        let j = []
        j.push(this.selectedRow.id)
        j.push(this.selectedRow.childJobs.map(x=>x.id))
        j = j.flat(2)
        j.sort((a,b)=>a-b)
        // throw "Pause"
        let x = await axios.post(`${this.getEndpoint}/api/print/directJobTicketBulk`, {jobs:j})
        if(x.data.error) throw x.data.error
        let printWindow = open("","Printing")
        printWindow.document.write("")
        printWindow.document.write(x.data.data.job.htmlToPrint)
        printWindow.setTimeout(()=>{
          printWindow.print()
          printWindow.document.write("")
        },500)
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error")
      }
    },
    async changeSelectedRow(){
      try {
        if(this.manualRoute) return;

        let id = this.$route.query.selected
        if(!id){
          this.showSelected = false
          this.selectedRow = null
          return
        }
        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${id}`)
        if(res.data.error) throw res.data.error;
        this.selectedRow = res.data.data

        this.selectedRow.dateOut = this.parseISODate(this.selectedRow.dateOut);
        this.selectedRow.dateIn = this.parseISODate(this.selectedRow.dateIn);
        this.selectedRow.dateToHand = this.parseISODate(this.selectedRow.dateToHand);

        this.selectedRow.item = this.selectedRow.Item.Asset.styleNo+(this.selectedRow.Item.colour?` (${this.selectedRow.Item.colour})`:'');
        let itemObj = {
          name: this.selectedRow.Item.Asset.styleNo+(this.selectedRow.Item.colour?` (${this.selectedRow.Item.colour})`:''),
          type: "item",
          id: this.selectedRow.itemId,
          itemId: this.selectedRow.itemId,
          assetId: this.selectedRow.Item.Asset.id
        }
        this.selectedRow.customItem = itemObj;

        await this.updateSelectedItems();
        this.showAddNew = false;
        this.showSelected = true;
        if(!(this.$route.query.selected && this.$route.query.selected==id)){
          await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, selected: id}})
        }
      } catch (error) {
        console.log(error)
      }
    },
    async attemptPrint(e){
      try {
          if(!e.pin&&!e.vsidToken) throw "Error Getting Credentials"
          let res = await axios.post(`${this.getEndpoint}/api/print/jobTicket/${this.$route.query.selected}`, e)
          if(res.data.error) throw res.data.error
      } catch (error) {
        console.log(error)
        this.snack(error)
      }
    },
    async rowClick(item){
      try {
        this.isEditable = false;

        window.scrollTo(0, 0);
        this.pagination.loading = true
        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${item.id}`)
        if(res.data.error) throw res.data.error;
        this.selectedRow = res.data.data

        this.selectedRow.dateOut = this.parseISODate(this.selectedRow.dateOut);
        this.selectedRow.dateIn = this.parseISODate(this.selectedRow.dateIn);
        this.selectedRow.dateToHand = this.parseISODate(this.selectedRow.dateToHand);

        this.selectedRow.item = this.selectedRow.Item.Asset.styleNo+(this.selectedRow.Item.colour?` (${this.selectedRow.Item.colour})`:'');
        let itemObj = {
          name: this.selectedRow.Item.Asset.styleNo+(this.selectedRow.Item.colour?` (${this.selectedRow.Item.colour})`:''),
          type: "item",
          id: this.selectedRow.itemId,
          itemId: this.selectedRow.itemId,
          assetId: this.selectedRow.Item.Asset.id
        }

        this.selectedRow.customItem = itemObj;

        await this.updateSelectedItems();

        this.showAddNew = false;
        this.showSelected = true;
        this.manualRoute = true;
        if(!(this.$route.query.selected && this.$route.query.selected==item.id)){
          await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, selected: item.id}})
        }
        this.manualRoute = false;

        await this.loadAlterations();

      } catch (error) {

        console.error(error);
        this.snack(error.msg || error, "error");

      } finally {
        this.pagination.loading = false
      }
    },
    viewRow(){
      this.$router.push(`/${this.pluralLower}/view/${this.selectedRow.id}`)
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    parseDate(date){
      if(!date) return null;
      return moment(this.parseISODate(date)).format("DD/MM/YYYY")
    },
    momentDateFormat (date, withTime=null) {
      if(!withTime){
        return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
      }
      return date ? moment(date).format('ddd, MMM Do YYYY h:mm:ss a') : '';
    },
    parseISODate(date){
      return (date?new Date(date).toISOString().substring(0, 10):null);
    },
    async closeMenu(){
      this.showSelected = false;
      this.showAddNew = false;
      if(this.$route.query.selected){
        await this.$router.replace({path: `/${this.pluralLower}`, query: null})
      }
      if(this.isEditable) await this.toggleChanges();
    },
    async showCreateMenu(){
      if(!(this.$route.query.create)){
        await this.$router.replace({path: `/${this.pluralLower}`, query: {create: "true"}})
      }

      this.formData = {Item: {item: null}};

      this.showSelected = false;
      this.showAddNew = true;
    },
    async saveJob(){
      try {
        this.createJobLoading = true
        this.formData.id = null

        if(!this.formData.totalCost) this.formData.totalCost = 0
        if(!this.formData.tailorCost) this.formData.tailorCost = 0

        if(this.formData.gender!==1){
          this.formData.alterationType = null;
          this.formData.itemAlterations = []
        }

        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.formData)
        if(res.data.error) throw res.data.error;
        this.snack(`${this.singular} Created 🎉`);

        await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, selected: res.data.data.id}})
        await this.getAllData();

        this.closeCreateJobDialog();

      } catch (error) {

        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeCreateJobDialog();

      } finally {

        this.createJobLoading = false

      }
    },
    async updateJob(){
      try {
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.selectedRow.id}`, this.selectedRow)
        if(res.data.error) throw res.data.error;

        this.snack(`${this.singular} Updated 🎉`);

        this.isEditable = false;
        await this.getAllData();
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    async updateJobStatus(newStatus, res){
      try {
        let x;
        if(newStatus==="sendOff") x = await axios.put(`${this.getEndpoint}/api/jobs/sendOff/${this.selectedRow.id}`, res)
        if(newStatus==="receiveIn") x = await axios.put(`${this.getEndpoint}/api/jobs/receiveIn/${this.selectedRow.id}`, res)
        if(newStatus==="handOff") x = await axios.put(`${this.getEndpoint}/api/jobs/handOff/${this.selectedRow.id}`, res)
        if(newStatus==="void") x = await axios.put(`${this.getEndpoint}/api/jobs/void/${this.selectedRow.id}`, res)
        if(x.data.error) throw x.data.error;

        this.selectedRow.status = x.data.data.status;
        this.selectedRow.sentAt = x.data.data.sentAt;
        this.selectedRow.sentBy = x.data.data.sentBy;
        this.selectedRow.receivedAt = x.data.data.receivedAt;
        this.selectedRow.receivedBy = x.data.data.receivedBy;
        this.selectedRow.handedOffAt = x.data.data.handedOffAt;
        this.selectedRow.handedOffBy = x.data.data.handedOffBy;
        this.selectedRow.voidAt = x.data.data.voidAt;
        this.selectedRow.voidBy = x.data.data.voidBy;
      } catch (error) {
        console.log(error)
        this.snack(error)
      }
    },
    async getAllData(){
      try {
        //used for pagination
        this.pagination.loading = true;
        let paginationData = {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sort: (this.options.sortBy.length>0)?this.options.sortBy[0]:"id",
          order: this.options.sortDesc[0],
          search: this.options.search
        }
        if(paginationData.sort==='out') paginationData.sort="dateOut";
        if(paginationData.sort==='in') paginationData.sort="dateIn";
        if(paginationData.sort==='hand') paginationData.sort="dateToHand";
        if(paginationData.sort==='parsedStatus') paginationData.sort="status";

        let uriFields = Object.keys(paginationData).map(x => {
          return x + "=" + (paginationData[x]!==undefined?encodeURIComponent(paginationData[x]):'')
        }).join("&");
        //used for pagination end

        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/tableDataPaginated?${uriFields}`)
        if(res.data.error) throw res.data.error;

        res.data.data.forEach(item => {
          item.event = item.Event?`${item.Event.name}`:'None';

          if(item.Item){
            item.customer = item.Item.Customer?`${item.Item.Customer.firstName} ${item.Item.Customer.lastName}`:"ERROR";
            item.item = item.Item.Asset?`${item.Item.Asset.styleNo} ${item.Item.colour?`(${item.Item.colour})`:''}`:"ERROR";
          }
          else{
            item.Item = {Customer: {}, Asset: {}};
          }

          item.out = this.momentDateFormat(item.dateOut)
          item.in = this.momentDateFormat(item.dateIn)
          item.hand = this.momentDateFormat(item.dateToHand)
          item.tailor = item.Tailor&&item.Tailor.metadata.shortName?item.Tailor.metadata.shortName:"None";
          item.parsedStatus = utils.parseJobStatus(item.status)
        });

        this.allData = res.data.data

        if(this.$route.query.selected) paginationData.selected = parseInt(this.$route.query.selected);
        if(this.$route.query.createFromAppointment) paginationData.createFromAppointment = this.$route.query.createFromAppointment;

        //used for pagination
        this.pagination.dataCount = res.data.total
        let shouldUpdate = false;
        let oldQuery = this.getURLQuery();
        let newQuery = {...paginationData};

        if(Object.keys(newQuery).length!==Object.keys(oldQuery).length) shouldUpdate = true;
        if(!shouldUpdate){
          for(let key of Object.keys(newQuery)){
            if(shouldUpdate) break;

            if(Array.isArray(newQuery[key])){
              if(newQuery[key].length!==oldQuery[key].length){
                shouldUpdate = true;
                break;
              }
              for(let i=0;i<newQuery[key].length-1;i++){
                if(newQuery[key][i]!==oldQuery[key][i]){
                  shouldUpdate = true;
                  break;
                }
              }
            }
            else if(newQuery[key]!==oldQuery[key]){
              shouldUpdate = true;
            }
          }
        }

        if(shouldUpdate){
          this.updatingRoute = true;
          if(this.init){
            if(this.$route.path===`/${this.pluralLower}`) await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, ...newQuery}});
          }
          else{
            if(this.$route.path===`/${this.pluralLower}`) await this.$router.push({path: `/${this.pluralLower}`, query: {...this.$route.query, ...newQuery}});
          }
          this.updatingRoute = false;
        }
        //used for pagination end

        // if(!this.$route.query.selected && this.allData.length>0){
        //   await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, selected: this.allData[0].id}})
        // }

        if(this.$route.query && this.$route.query.selected){
          let row = parseInt(this.$route.query.selected);

          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${row}`)
          if(res.data.error) throw res.data.error;
          this.selectedRow = res.data.data

          this.selectedRow.dateOut = this.parseISODate(this.selectedRow.dateOut);
          this.selectedRow.dateIn = this.parseISODate(this.selectedRow.dateIn);
          this.selectedRow.dateToHand = this.parseISODate(this.selectedRow.dateToHand);

          if(this.selectedRow.Item){
            this.selectedRow.item = this.selectedRow.Item.Asset.styleNo+(this.selectedRow.Item.colour?` (${this.selectedRow.Item.colour})`:'');
            await this.updateSelectedItems();

            let itemObj = {
              name: this.selectedRow.Item.Asset.styleNo+(this.selectedRow.Item?.colour?` (${this.selectedRow.Item.colour})`:''),
              type: "item",
              id: this.selectedRow.Item.id,
              itemId: this.selectedRow.Item.id,
              assetId: this.selectedRow.Item.Asset.id
            }
            this.selectedRow.customItem = itemObj;
          }

          this.showAddNew = false;
          this.showSelected = true;
        }

        await this.loadAlterations();

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.pagination.loading = false;
      }
    },
    async createdCustomerChanged(){
      this.formData.Item.item = null;
      await this.updateItems();
    },
    async updateItems(){
      try{
        this.loadingItems = true;

        let initItems = [];

        if(this.formData.Item.customerId){
          let res = await axios.get(`${this.getEndpoint}/api/items/byCustomer/${this.formData.Item.customerId}`)
          if(res.data.error) throw res.data.error;

          let customerItems = res.data.data;

          initItems.push({disabled:true, name: "-----Customer Items-----"})
          if(customerItems.length===0){
            initItems.push({disabled:true, name: "None"})
          }
          else{
            for(let item of customerItems){
              let name = '';
              name+=item.Asset.styleNo;
              if(item.colour && item.colour.length>0){
                name+=" ("+item.colour+")"
              }

              let obj = {
                name: name,
                id: item.id,
                type: "item"
              };
              initItems.push(obj);
            }
          }
        }
        else{
          this.formData.Item.item = null;
        }

        initItems.push({disabled:true, name: "-----Default Items-----"})
        if(this.assets.length===0){
          initItems.push({disabled:true, name: "None"})
        }
        else{
          for(let asset of this.assets){
            let obj = {
              name: asset.styleNo,
              id: asset.id,
              type: "asset"
            };
            initItems.push(obj);
          }
        }

        this.items = initItems;
      }
      catch (e) {
        console.error(e);
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loadingItems = false;
      }
    },
    async selectedCustomerChanged(){
      this.selectedRow.customItem = null;
      await this.updateSelectedItems();
    },
    async updateSelectedItems(){
      try{
        this.loadingItems = true;

        let initItems = [];

        if(this.selectedRow.Item.Customer.id){
          let res = await axios.get(`${this.getEndpoint}/api/items/byCustomer/${this.selectedRow.Item.Customer.id}`)
          if(res.data.error) throw res.data.error;

          let customerItems = res.data.data;

          initItems.push({disabled:true, name: "-----Customer Items-----"})
          if(customerItems.length===0){
            initItems.push({disabled:true, name: "None"})
          }
          else{
            for(let item of customerItems){
              let name = '';
              name+=item.Asset.styleNo;
              if(item.colour && item.colour.length>0){
                name+=" ("+item.colour+")"
              }

              let obj = {
                name: name,
                id: item.id,
                type: "item",
                itemId: item.id,
                assetId: item.Asset.id
              };
              initItems.push(obj);
            }
          }
        }
        else{
          this.selectedRow.customItem = null;
        }

        initItems.push({disabled:true, name: "-----Default Items-----"})
        if(this.assets.length===0){
          initItems.push({disabled:true, name: "None"})
        }
        else{
          for(let asset of this.assets){
            let obj = {
              name: asset.styleNo,
              id: asset.id,
              type: "asset"
            };
            initItems.push(obj);
          }
        }

        this.selectedItems = initItems;
      }
      catch (e) {
        console.error(e);
        this.snack(e.msg || e, "error");
      }
      finally {
        this.loadingItems = false;
      }
    },
    async itemChanged(){
      try{
        this.selectedRow.itemAlterations = [];
        this.selectedRow.alterationType = null;
        this.$forceUpdate();
      }
      catch (e){
        console.error(e);
        this.snack(e.msg || e, "error");
      }
    },
    async loadAlterations(create=false, linked=false){
      try{
        this.alterationsLoading = true;

        if(!create && !this.selectedRow){
          return;
        }

        if(create && this.formData.alterationType===null){
          this.formDataAlterations = [];
          this.formData.itemAlterations = [];
          return;
        }
        else if(!create && this.selectedRow.alterationType===null){
          this.alterations = [];
          this.selectedRow.itemAlterations = [];
          return;
        }

        if(create){
          let res = await axios.get(`${this.getEndpoint}/api/alterations/byType/${this.formData.alterationType}`)
          if(res.data.error) throw res.data.error;
          this.formDataAlterations = res.data.data;
          this.formData.itemAlterations = [];
          this.calculateCustomerCostForNewUnlinkedJob()
        }
        else if(linked){
          this.linkJobDialog.jobData.itemAlterations = [];
          let res = await axios.get(`${this.getEndpoint}/api/alterations/byType/${this.linkJobDialog.jobData.alterationType}`)
          if(res.data.error) throw res.data.error;

          if(this.linkJobDialog?.jobData?.parentJob){
            let arr = []
            arr = arr.concat(this.linkJobDialog.jobData?.parentJob.itemAlterations.map(x=>x.id))
            arr = arr.concat(this.linkJobDialog.jobData?.parentJob?.childJobs.map(x=>x.itemAlterations.map(y=>y.id)))
            arr = arr.flat(2)
            this.linkJobDialog.jobDataAlterations = res.data.data.filter(x=>!arr.includes(x.id));
          }else if(this.linkJobDialog?.jobData?.childJobs?.length>0){
            let arr = []
            arr = arr.concat(this.selectedRow.itemAlterations.map(x=>x.id))
            arr = arr.concat(this.selectedRow.childJobs.map(x=>x.itemAlterations.map(y=>y.id)))
            arr = arr.flat(2)
            this.linkJobDialog.jobDataAlterations = res.data.data.filter(x=>!arr.includes(x.id));
          }else{
            let arr = []
            arr = arr.concat(this.selectedRow.itemAlterations.map(x=>x.id))
            arr = arr.flat(2)
            this.linkJobDialog.jobDataAlterations = res.data.data.filter(x=>!arr.includes(x.id));
          }
          this.calculateCustomerCostForNewLinkJob()
        }
        else{
          let res = await axios.get(`${this.getEndpoint}/api/alterations/byType/${this.selectedRow.alterationType}`)
          if(res.data.error) throw res.data.error;

          let alterations = res.data.data;

          if(this.selectedRow.parentJob){
            for(let alt of this.selectedRow.parentJob.itemAlterations){
              alterations = alterations.filter(x => x.id!==alt.id);
            }

            for(let cj of this.selectedRow.parentJob.childJobs){
              if(cj.id===this.selectedRow.id) continue;
              for(let alt of cj.itemAlterations){
                alterations = alterations.filter(x => x.id!==alt.id);
              }
            }
          }
          else if(this.selectedRow.childJobs?.length>0){
            for(let cj of this.selectedRow.childJobs){
              for(let alt of cj.itemAlterations){
                alterations = alterations.filter(x => x.id!==alt.id);
              }
            }
          }

          this.alterations = alterations;
          this.calculateCustomerCost()
        }
      }
      catch (e){
        console.error(e);
        this.snack(e.msg || e, "error");
      }
      finally {
        this.alterationsLoading = false;
      }
    },
    showCreateAssetDialog(usage="create"){
      this.createAssetDialog = true;
      this.assetUsage = usage;
    },
    closeCreateAsset(){
      this.assetUsage = "create";
      this.createAssetDialog = false;
      this.newAsset = {};
      this.assetLoading = false;
    },
    async createAsset(usage="create"){
      try{
        this.assetLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/assets`, this.newAsset)
        if(res.data.error) throw res.data.error;

        if(usage==="create"){
          this.formData.Item.item = {
            id: res.data.data.data.id,
            name: res.data.data.data.styleNo,
            type: "asset",
            itemId: null,
            assetId: res.data.data.data.id
          }
        }
        else if(usage==="update"){
          this.selectedRow.customItem = {
            id: res.data.data.data.id,
            name: res.data.data.data.styleNo,
            type: "asset",
            itemId: null,
            assetId: res.data.data.data.id
          }
        }
        else{
          throw "Invalid item usage."
        }

        if(res.data.data.created){
          this.snack(`Asset Created 🎉`);

          res = await axios.get(`${this.getEndpoint}/api/assets`)
          if(res.data.error) throw res.data.error;
          this.assets = res.data.data;

          if(usage==="create"){
            await this.updateItems();
          }
          else if(usage==="update"){
            await this.updateSelectedItems();
          }
        }
        else{
          this.snack(`Asset already exists. Adding to form...`);
        }

        this.closeCreateAsset();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.assetLoading = false;
      }
    },
    showCreateTailorDialog(){
      this.createTailorDialog = true;
    },
    closeCreateTailor(){
      this.createTailorDialog = false;
      this.newTailor = {};
      this.tailorLoading = false;
    },
    async createTailor(){
      try{
        this.tailorLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/tailors`, this.newTailor)
        if(res.data.error) throw res.data.error;

        this.formData.tailorId = res.data.data.data.id;

        if(res.data.data.created){
          this.snack(`Tailor Created 🎉`);

          res = await axios.get(`${this.getEndpoint}/api/tailors/excludeHidden`)
          if(res.data.error) throw res.data.error;
          this.tailors = res.data.data;
        }
        else{
          this.snack(`Tailor already exists. Adding to form...`);
        }

        this.closeCreateTailor();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.tailorLoading = false;
      }
    },
    async editTailorCost(){
      try{
        this.editTailorCostPostComplete.loading = true
        let res = await axios.put(`${this.getEndpoint}/api/jobs/tailorcost/${this.selectedRow.id}`, {value: this.editTailorCostPostComplete.value})
        if(res.data.error) throw res.data.error;
        this.snack("Tailor Cost Edited")
        this.closeEditTailorCostPostComplete();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.tailorLoading = false;
      }
    },
    showEditTailorCostPostComplete(){
      this.editTailorCostPostComplete.isOpen = true
      this.editTailorCostPostComplete.value = this.selectedRow.tailorCost
      this.editTailorCostPostComplete.loading = false
    },
    closeEditTailorCostPostComplete(){
      this.editTailorCostPostComplete.isOpen = false
      this.editTailorCostPostComplete.loading = false
    },
    async editCustomerCost(){
      try{
        this.editCustomerCostPostComplete.loading = true
        let res = await axios.put(`${this.getEndpoint}/api/jobs/customerCost/${this.selectedRow.id}`, {value: this.editCustomerCostPostComplete.value})
        if(res.data.error) throw res.data.error;
        this.snack("Customer Cost Edited")
        this.closeEditCustomerCostPostComplete();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.tailorLoading = false;
      }
    },
    showEditCustomerCostPostComplete(){
      this.editCustomerCostPostComplete.isOpen = true
      this.editCustomerCostPostComplete.value = this.selectedRow.totalCost
      this.editCustomerCostPostComplete.loading = false
    },
    closeEditCustomerCostPostComplete(){
      this.editCustomerCostPostComplete.isOpen = false
      this.editCustomerCostPostComplete.loading = false
    },
    showCreateEventDialog(usage="create"){
      this.createEventDialog = true;
      this.eventUsage = usage;
    },
    closeCreateEvent(){
      this.eventUsage = "create";
      this.createEventDialog = false;
      this.newEvent = {};
      this.eventLoading = false;
    },
    async createEvent(usage="create"){
      try{
        this.eventLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/events`, this.newEvent)
        if(res.data.error) throw res.data.error;

        if(usage==="create"){
          this.formData.eventId = res.data.data.id;
        }
        else if(usage==="update"){
          this.selectedRow.eventId = res.data.data.id;
        }
        else{
          throw "Invalid event usage."
        }

        this.snack(`Event Created 🎉`);

        res = await axios.get(`${this.getEndpoint}/api/events`)
        if(res.data.error) throw res.data.error;
        this.events = res.data.data;

        this.closeCreateEvent();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.eventLoading = false;
      }
    },
    showCreateCustomerDialog(usage="create"){
      this.createCustomerDialog = true;
      this.customerUsage = usage;
    },
    existingCustomerSelected(){
      this.formData.Item.customerId = this.existingData.id;
      this.closeCreateCustomer();
    },
    closeCreateCustomer(){
      this.customerUsage = "create";
      this.createCustomerDialog = false;
      this.newCustomer = {address: {}};
      this.existingData = null;
      this.customerLoading = false;
    },
    async createCustomer(usage="create"){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        if(newC.existing){
          this.existingData = newC;
          this.snack("Customer with this phone number already exists.")
          return;
        }

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        if(usage==="create"){
          this.formData.Item.customerId = newC.id;
          await this.updateItems();
        }
        else if(usage==="update"){
          this.selectedRow.Item.Customer.id = newC.id;
          await this.updateSelectedItems();
        }
        else if(usage==="event"){
          this.newEvent.customerId = newC.id;
        }
        else{
          throw "Invalid customer usage."
        }
        this.snack("Customer Created!", "success")
        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },
    async confirmCreateCustomer(usage="create"){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers/force`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        if(usage==="create"){
          this.formData.Item.customerId = newC;
        }
        else if(usage==="update"){
          this.selectedRow.Item.Customer.id = newC;
        }
        else if(usage==="event"){
          this.newEvent.customerId = newC;
        }
        else{
          throw "Invalid customer usage."
        }
        this.snack("Customer Created!", "success")
        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },
    async toggleChanges(){
      if(this.isEditable) await this.getAllData();

      this.isEditable = !this.isEditable;
    },
    async voidJob(){
      try {
        this.deleteLoading = true
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/void/${this.selectedRow.id}`)
        if(res.data.error) throw res.data.error
        this.snack(`${this.singular} Voided 🎉`);

        this.closeDeleteDialog();
        await this.getAllData();

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    closeDeleteDialog(){
      this.confirmDeleteDialog = false;
      this.deleteLoading = false;
    },
    async openCreateJobDialog(appointmentData=null){
      if(appointmentData){
        let modifiedQuery = {...this.$route.query};
        delete modifiedQuery.createFromAppointment;
        await this.$router.replace({path: this.$route.path, query: modifiedQuery})

        this.formData.gender = appointmentData.gender || 0;
        this.formData.Item.customerId = appointmentData.customerId;
        this.formData.appointmentId = appointmentData.id;
        if(this.formData.Item.customerId){
          await this.createdCustomerChanged();
        }
        this.appointmentData.id = appointmentData.id;
      }

      this.formData.branchId = this.getLocations.length>0?this.getLocations[0].id:null
      this.formData.dateOut = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.createJobDialog = true
    },
    resetCreateJobDialog(){
      this.formData = {Item: {item: null}, gender: 0, type: 0, metadata: {}};
      this.appointmentData = {
        id: null
      }
    },
    closeCreateJobDialog(){
      this.createJobDialog = false
      this.formData = {Item: {item: null}, gender: 0, type: 0, metadata: {}};
    },
    closePhotoDialog(){
      this.photoDialog.isOpen = false
      let tracks = this.$refs.camera.srcObject.getTracks()
      tracks.forEach(track=>track.stop())
      this.$refs.camera.srcObject = null
      this.$refs.canvas.getContext('2d').clearRect(0,0,700,525)
      this.photoDialog.isPhotoTaken = false
    },
    openPhotoDialog(){
      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({video:true, audio:false})
          .then(stream=>{
            this.$refs.camera.srcObject = stream;
          })
          .catch(error=>{
            console.log("Something went wrong!", error);
          });
      }
      if(this.selectedRow.metadata && this.selectedRow.metadata.media && this.selectedRow.metadata.media.length>0){
        this.selectedRow.metadata.media.reverse()
        this.setPhotoToDisplay(this.selectedRow.metadata.media[0].url)
      }
      this.photoDialog.isOpen = true
    },
    async snapAndSave(){
      try {
        this.photoDialog.snapAndSaveLoader = true
        this.takePhoto()
        await this.addPhotoToJob()
      } catch (error) {
        console.log(error)
        this.snack(error)
      }finally{
        this.photoDialog.snapAndSaveLoader = false
      }
    },
    takePhoto(){
      this.photoDialog.flash = true
      setTimeout(() => {
          this.photoDialog.flash = false
        }, 50);
      this.photoDialog.isPhotoTaken = true
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 700,525);
    },
    retryPhoto(){
      this.photoDialog.isPhotoTaken = false
    },
    async addPhotoToJob(){
      try {
        this.photoDialog.addPhotoLoader = true
        let data = new FormData()
        let img = this.$refs.canvas.toDataURL('image/jpeg', 1.0)
        data.append('file', img)
        let res = await axios.post(`${this.getEndpoint}/api/jobs/photo/${this.$route.query.selected}`, data, {
          header : {
            'Content-Type' : 'multipart/form-data'
          }
        })
        if(res.data.error) throw res.data.error
        this.photoDialog.isPhotoTaken = false
        if(!this.selectedRow.metadata.media) this.selectedRow.metadata.media = []
        this.selectedRow.metadata.media = res.data.data.reverse()
      } catch (error) {
        console.log(error)
        this.snack(error.msg||error)
      } finally {
        this.photoDialog.addPhotoLoader = false
      }
    },
    async deletePhoto(img){
      try {
        if(!img) throw "Image not specified."
        let res = await axios.delete(`${this.getEndpoint}/api/jobs/photo/${this.$route.query.selected}`, {data:{url:img}})
        if(res.data.error) throw res.data.error
        this.selectedRow.metadata.media = res.data.data.reverse()
        if(this.selectedRow.metadata.media.length<1) this.photoDialog.photoToDisplay = null
        this.snack("Image Deleted from Server.")
      } catch (error) {
        console.log(error)
        this.snack(error.msg || error)
      }
    },
    setPhotoToDisplay(img){
      this.photoDialog.photoToDisplay = img
    },
    async openLinkJobDialog(linkId){
      this.linkJobDialog.jobData = {...this.selectedRow}
      this.linkJobDialog.jobData.parentId = linkId
      this.linkJobDialog.jobData.tailorId = ''
      this.linkJobDialog.jobData.tailorCost = 0
      this.linkJobDialog.jobData.Tailor = null
      this.linkJobDialog.jobData.tailor = null
      this.linkJobDialog.jobData.itemAlterations = []
      this.linkJobDialog.jobData.dateOut = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.linkJobDialog.isOpen = true
      await this.loadAlterations(false,true)
    },
    closeLinkJobDialog(){
      this.$refs.createLinkJobForm.reset()
      this.linkJobDialog.jobData = {}
      this.linkJobDialog.isOpen = false
      this.linkJobDialog.loading = false
    },
    async createLinkedJob(){
      try {
        this.linkJobDialog.loading = true
        if(this.linkJobDialog.jobData.id) this.linkJobDialog.jobData.id = null

        if(!this.linkJobDialog.jobData.totalCost) this.linkJobDialog.jobData.totalCost = 0
        if(!this.linkJobDialog.jobData.tailorCost) this.linkJobDialog.jobData.tailorCost = 0

        if(!this.linkJobDialog.jobData.parentId) throw "No Parent ID Supplied. Please refresh the page and retry."
        console.log(this.linkJobDialog.jobData)
        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.linkJobDialog.jobData)
        if(res.data.error) throw res.data.error;
        this.snack(`${this.singular} Created 🎉`);

        await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, selected: res.data.data.id}})
        await this.getAllData();

        this.closeLinkJobDialog();
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
        this.closeLinkJobDialog();
      } finally {
        this.linkJobDialog.loading = false
      }
    },
    lookupTailorName(id){
      return this.tailors.find(x=>x.id==id) || {}
    },
  },
}
</script>
